<template>
  <div class="emoji-container d-flex">
    <div class="emoji">
      <input :id="base + 1" class="checkbox1" :name="base" type="radio" value="1"/>
      <label :for="base + 1" ></label>
    </div>
    <div class="emoji">
      <input :id="base + 2" class="checkbox2" :name="base" type="radio" value="2"/>
      <label :for="base + 2" ></label>
    </div>
    <div class="emoji">
      <input :id="base + 3" class="checkbox3" :name="base" type="radio" value="3"/>
      <label :for="base + 3" ></label>
    </div>
    <div class="emoji">
      <input :id="base + 4" class="checkbox4" :name="base" type="radio" value="4"/>
      <label :for="base + 4" ></label>
    </div>
    <div class="emoji">
      <input :id="base + 5" class="checkbox5" :name="base" type="radio" value="5"/>
      <label :for="base + 5" ></label>
    </div>
  </div>
</template>

<script setup>

import {onMounted, ref, watch} from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  base: {
    type: String,
    default: "checkbox"
  },
  checked: {
    type: String,
    default: null
  }
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['setPoint'])

const point = ref(props.checked)

onMounted(() => {
  getQuestionValue()
})

watch(() => point.value, () => {
  setSelectedValue()
  emit('setPoint', point.value)
})

function getQuestionValue(){
  let name = props.base
  // eslint-disable-next-line no-undef
  $(`input[type='radio'][name=${name}]`).change(() => {
    // eslint-disable-next-line no-undef
    point.value = $(`input[type='radio'][name=${name}]:checked`).val();
  });
}

function setSelectedValue(){
  // eslint-disable-next-line no-undef
  $("#" + props.base + point.value).checked = true
}

</script>

<style scoped>
emoji-container{
  justify-items: center;
  align-items: center;
}

.emoji {
  justify-content: center;
  align-items: center;
  margin: 3px;
}

input[type = radio] {
  display: none;
}

input + label {
  font-size: 1.2rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: .1rem solid transparent;
  border-radius: 50%;
  background: transparent;
  transition: .1s all;
  cursor: pointer;
  z-index: 999 !important;
}

input + label:hover {
  transform: scale(.95);
}

.checkbox1 + label:after {
  content: "😡";
}
.checkbox2 + label:after {
  content: "🙁";
}
.checkbox3 + label:after {
  content: "😐";
}
.checkbox4 + label:after {
  content: "😊";
}
.checkbox5 + label:after {
  content: "🤩";
}


input:checked + label {
  font-size: 1.8rem;
  background: transparent;
  transform: scale(1.1);
  justify-content: center;
  justify-items: center;
  align-items: center;
}

input:checked + label:hover {
  font-size: 1.8rem;
  transform: scale(1.05);
  background: transparent;
}




</style>